import { defineNuxtPlugin } from "nuxt/app";
import { O360ClickOutsideDirective } from "@airpr/360-ui-components";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("O360-click-outside", O360ClickOutsideDirective);
});
